import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Done';
import HelpOutline from '@material-ui/icons/HelpOutline';

import styles from '../../styles.module.css';
import { selectLayout } from '../../../../../state';

function ColumnList({
  selectedColumns,
  supportedColumns,
  handleColumnToggle,
}) {
  const layout = useSelector(selectLayout);
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [statPopovers, setStatPopovers] = useState([]);

  const defineStatPopover = (e, stat) => {
    e.preventDefault();

    setPopoverAnchor(!popoverAnchor && e.currentTarget.tagName ? e.currentTarget : null);

    setStatPopovers({
      ...statPopovers,
      [stat]: popoverAnchor,
    });
  };

  const defineStatPopoverClose = (stat) => {
    setStatPopovers({
      ...statPopovers,
      [stat]: null,
    });
  };

  const sc = supportedColumns.sort((a, b) => a.labelStr.localeCompare(b.labelStr));

  return (
    <List className={styles.controlsContainer}>
      {sc.map((column, index) => (
        <ListItem
          key={`${column.name}${column.stat}`}
          className={selectedColumns.includes(column.stat) ? styles.columnEnabled : styles.columnOption}
          onClick={() => handleColumnToggle(column.stat)}
        >
          <Avatar
            className={`${styles.statAvatar}`}
            style={{ animationDelay: `${index * 25}ms` }}
          >
            {column.stat.length < 4 ? column.stat : ' '}
          </Avatar>

          <Avatar
            color="primary"
            className={styles.onAvatar}
            style={{
              animationDelay: `${index * 25}ms`,
              backgroundColor: layout.brandPrimaryColor,
            }}
          >
            <CheckIcon />
          </Avatar>

          <ListItemText primary={column.label} className={styles.listItemText} />

          {column.description // if a description is available, add a popover element
            && (
              <div style={{ float: 'right' }}>
                <IconButton
                  style={{ padding: 0 }}
                  onMouseEnter={(e) => defineStatPopover(e, column.stat)}
                  onMouseLeave={() => defineStatPopoverClose(column.stat)}
                >
                  <HelpOutline />
                </IconButton>
                <Popover
                  open={Boolean(statPopovers[column.stat])}
                  anchorEl={statPopovers[column.stat]}
                  style={{ pointerEvents: 'none' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <div style={{ maxWidth: 300 }} className={styles.defineStatPopover}>{column.description}</div>
                </Popover>
              </div>
            )}
        </ListItem>
      ))}
    </List>
  );
}

ColumnList.propTypes = {
  selectedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  supportedColumns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ColumnList;
